import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../request/request";

export const getCourseDetail = createAsyncThunk(
  "courseDetail",
  async (params = {}, { rejectWithValue }) => {
    let url = "/api/v1/content-creator-tenant-courses";
    if (params.search && params.searchText) {
      url += `?search=${encodeURIComponent(params.searchText)}`;
    }
    const response = await request(url, { method: "GET", auth: true });

    if (response?.data) {
      return response?.data;
    }
    const { error } = response;
    throw rejectWithValue(error || "Something went wrong");
  }
);
